/**
 * Dárkové balení: svázání v košíku
 * ---------------------------------------------------------------
 * Globální modul (běží všude přes overlay-group). Stará se o to, aby se
 * položka „Dárkové balení“ chovala jako svázaná s produktem, u kterého
 * byla zakoupena:
 *
 *  - SYNCHRONIZACE MNOŽSTVÍ – množství balení vždy odpovídá počtu
 *    zabalených kusů dané varianty (řádky produktu s viditelným štítkem
 *    „🎁 Dárkové balení“).
 *  - AUTOMATICKÉ ODEBRÁNÍ – když v košíku nezůstane žádný zabalený kus
 *    dané varianty, balení se odebere.
 *  - ZÁMEK ŘÁDKU – u řádku balení skryjeme měnič množství i křížek, aby
 *    šlo měnit jen přes produkt.
 *
 * Balení i jeho vazbu poznáme podle line properties, které nasazuje
 * product-gift-wrap.js:
 *   _darkove_baleni = '1'              → řádek je balení
 *   _baleni_variant = <variant id>     → ke které variantě produktu patří
 *   '🎁 Dárkové balení' (na produktu)  → tento kus je objednán se zabalením
 *
 * Cenu řeší produkt balení v adminu – tady jen dorovnáváme množství.
 */
(function () {
  const WRAP_FLAG = '_darkove_baleni';
  const WRAP_VARIANT = '_baleni_variant';
  const PRODUCT_FLAG = '🎁 Dárkové balení';

  class ProductGiftWrapCart {
    constructor() {
      this.busy = false;
      this.wrapVariantIds = new Set();

      // Reagujeme na každou změnu košíku (theme publikuje cart:updated).
      document.addEventListener('cart:updated', (event) => {
        const cart = event.detail && event.detail.cart;
        this.handle(cart);
      });

      // Výchozí dorovnání podle aktuálního stavu košíku.
      this.fetchCart().then((cart) => this.handle(cart));
    }

    /** Hlavní vstup – dorovná množství a zamkne řádky. */
    handle(cart) {
      if (!cart || !Array.isArray(cart.items) || this.busy) return;

      this.collectWrapVariants(cart);
      this.lockRows();
      this.reconcile(cart);
    }

    /** Zapamatuje si varianty produktu balení (kvůli zámku řádků v DOM). */
    collectWrapVariants(cart) {
      cart.items.forEach((item) => {
        if (this.isWrap(item)) this.wrapVariantIds.add(item.variant_id || item.id);
      });
    }

    isWrap(item) {
      return item.properties && item.properties[WRAP_FLAG] === '1';
    }

    /** Má daný řádek produktu viditelný štítek „objednáno se zabalením“? */
    isWrapped(item) {
      return item.properties && item.properties[PRODUCT_FLAG];
    }

    /**
     * Dorovná množství / odebere balení podle počtu zabalených kusů.
     * Pracuje vždy jen s první nutnou změnou a po ní nechá košík
     * překreslit – další kolo dorovná zbytek (drží to jednoduché a bezpečné).
     */
    reconcile(cart) {
      const wraps = cart.items.filter((item) => this.isWrap(item));
      if (!wraps.length) return;

      for (const wrap of wraps) {
        const variantId = parseInt(wrap.properties[WRAP_VARIANT], 10);

        // Počet zabalených kusů této varianty (může být víc řádků produktu).
        const wantedQty = cart.items
          .filter((item) => !this.isWrap(item))
          .filter((item) => (item.variant_id || item.id) === variantId && this.isWrapped(item))
          .reduce((sum, item) => sum + item.quantity, 0);

        if (wantedQty !== wrap.quantity) {
          this.changeQuantity(wrap.key, wantedQty);
          return; // jedna změna za kolo – zbytek dorovná příští cart:updated
        }
      }
    }

    /** Změní množství řádku balení (0 = odebrat) a překreslí košík. */
    changeQuantity(lineKey, quantity) {
      this.busy = true;

      const body = JSON.stringify({ id: lineKey, quantity: quantity });

      fetch(`${window.FoxTheme.routes.cart_change_url}`, {
        ...window.FoxTheme.utils.fetchConfig(),
        body,
      })
        .then((response) => response.json())
        .catch((error) => console.error('Gift wrap sync failed:', error))
        .finally(() => {
          this.busy = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
        });
    }

    /** Zamkne v DOM všechny řádky balení (skryje množství i odebrání). */
    lockRows() {
      if (!this.wrapVariantIds.size) return;

      this.wrapVariantIds.forEach((variantId) => {
        document.querySelectorAll(`.cart-item[data-variant-id="${variantId}"]`).forEach((row) => {
          row.classList.add('product-gift-wrap-locked');
        });
      });
    }

    fetchCart() {
      return fetch(`${window.FoxTheme.routes.cart_url}.js`)
        .then((response) => response.json())
        .catch(() => null);
    }
  }

  const init = () => new ProductGiftWrapCart();
  if (window.FoxTheme && window.FoxTheme.routes) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
